import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

const alignToRight = css`
	right: 0;
`;

const alignToLeft = css`
	left: 0;
`;

export const Backdrop = styled.div`
	width: 100%;
	height: 100%;
	background-color: rgba(50, 50, 50, 0.3);
	position: fixed;
	z-index: 3;
	top: 0%;
	left: 0;
	display: ${props => (props.toggle ? 'block' : 'none')};
`;

export const Wrapper = styled.div`
	background-color: ${colors.white};
	position: fixed;
	top: 0%;
	z-index: 4;
	height: -webkit-fill-available;
	display: flex;
	flex-direction: column;
	width: ${props => props.width};
	overflow: auto;
	&::-webkit-scrollbar {
		width: 6px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: #888;
		border-radius: 4px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: #555;
	}
	&::-webkit-scrollbar-track {
		background-color: #f2f2f2;
		border-radius: 4px;
	}
	${props => (props.toRight === true ? alignToRight : alignToLeft)};
`;

export const HeadingWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 3%;
`;

export const Heading = styled.div`
	color: ${colors.grey5};
	font-weight: 600;
`;

export const CloseWraper = styled.div``;
